import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';

import { LaunchPageComponent } from './launch-page.component';
import { CanActivateGuard } from '../../modules/can-activate.guard';
import { MY_WINDOW_TOKEN } from '../quiz-submit-error-component/quiz-submit-error.component';

const routes: Routes = [
  {
    path: 'launch',
    component: LaunchPageComponent,
    canActivate: [CanActivateGuard],
    data: { title: 'Launch Page' },
  },
];

@NgModule({
  declarations: [LaunchPageComponent],
  imports: [CommonModule, RouterModule.forChild(routes)],
  providers: [CanActivateGuard, { provide: MY_WINDOW_TOKEN, useValue: window }],
})
export class LaunchPageModule {}
